const className =
  "appearance-none relative block w-full px-3 py-2 border border-input bg-input placeholder-gray-400 text-primary rounded-lg focus:outline-hidden focus:ring-2 focus:ring-indigo-300 dark:disabled:bg-transparent disabled:bg-transparent focus:z-10 text-xs md:text-sm";

export const ErrorMessage = ({ message }) => {
  return (
    <span className="text-red-400 text-xs text-center">
      {message}
    </span>
  );
};

export const Input = ({ dataTestId, ref, ...props }) => {
  return (
    <input
      className={className}
      data-testid={dataTestId}
      ref={ref}
      {...props}
    />
  );
};
